export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9631.edcd0d68.jpg";